const initialState = {
    language: "pl",
  }
  
  export default initialState
  